<template>
    <section class="navbar">
        <div class="menubar">
           <div class="fl">
                <i class="fa fa-th-list" :class="{'fa-rotate-90':$store.state.collapse}" @click="changeCollapse"></i>
                <!-- 面包屑导航 -->
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <transition-group name="breadcrumb">
                        <el-breadcrumb-item v-for="item in breadList" :key="item.path">{{item.meta.title}}</el-breadcrumb-item>
                    </transition-group>
                </el-breadcrumb>
           </div>

            <!-- 右侧菜单项 -->
            <div class="fr menu-right">

                <el-tooltip class="item fl" effect="dark" content="全屏" placement="bottom">
                    <i class="fa fa-arrows-alt" @click="fullScreen"></i>
                </el-tooltip>
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        <img class="person-img fl" src="../../../assets/img/avatar.png" alt="">
                        <i class="person-name fl">{{userInfo.name}}</i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="changPwd">修改密码</el-dropdown-item>
                        <el-dropdown-item @click.native="logOut" divided>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

        </div>

        <!-- 修改密码框 -->
        <el-dialog :visible.sync="showPwdDialog" title="修改密码" width="400px" @closed="$refs.pwdForm.clearValidate()" append-to-body>
            <el-form :model="pwdForm" size='small' label-width="100px" ref="pwdForm" :rules="pwdFormRules">
                <el-form-item label="旧密码：" prop='loginToken'>
                    <el-input type="password" v-model="pwdForm.loginToken"></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop='newLoginToken'>
                    <el-input type="password" v-model="pwdForm.newLoginToken"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop='newLoginTokenCheck'>
                    <el-input type="password" v-model="pwdForm.newLoginTokenCheck"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="showPwdDialog = false">取消</el-button>
                <el-button type="primary" @click="submitPwd" v-loading="submitPwdLoading">保存</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
import ThemeColor from '@/components/ThemeColor'
import screenfull from 'screenfull'
export default {
    data() {
        const checkToken = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.pwdForm.newLoginToken) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
            showPwdDialog: false,
            submitPwdLoading: false,
            pwdForm: {},
            pwdFormRules: {
                loginToken: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
                newLoginToken: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                newLoginTokenCheck: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: checkToken, trigger: 'blur' }
                ]
            }
        }
    },
    computed: {
        breadList() {
            // 如果有重定向，则是由于没有子菜单(因此过滤掉)
            return this.$route.matched.filter(route => !route.redirect)
        }
    },
    methods: {
        // 改变左侧菜单收缩
        changeCollapse() {
            this.$store.commit('SET_COLLAPSE', !this.$store.state.collapse)
        },
        // 修改密码
        changPwd() {
            this.showPwdDialog = true
        },
        // 修改密码
        submitPwd() {
            this.$refs.pwdForm.validate(valid => {
                if (!valid) return
                this.$http('PUT', `/principal/${this.userInfo.id}id/updateLoginToken`, {
                    data: this.pwdForm,
                    showMsg: true,
                    self: this,
                    loading: 'submitPwdLoading'
                }).then(res => {
                    if (res.data.code === 200) {
                        this.showPwdDialog = false
                    }
                })
            })
        },
        // 退出登录
        logOut() {
            this.$router.replace({})
            sessionStorage.removeItem('nameList')
            sessionStorage.removeItem('token')
            location.reload()
        },
        // 全屏
        fullScreen() {
            if (!screenfull.enabled) {
                this.$message({
                    message: '抱歉，您使用的浏览器不支持全屏~',
                    type: 'warning'
                })
                return false
            }
            screenfull.toggle()
        }
    },
    components: {
        ThemeColor
    }
}
</script>

<style lang="scss" scoped>
.menubar {
  height: 56px;
  line-height: 56px;
  overflow: hidden;
  padding: 0 12px;
  background-color: rgb(54, 60, 66);
  color: #fff !important;
  .fa {
    // color: #363c42;
    color: #fff;
    cursor: pointer;
    transition: all 0.4s;
  }
  .fa-arrows-alt {
    line-height: 50px;
    font-size: 20px;
  }
  .menu-right {
    height: 50px;
    margin-right: 20px;
  }
  .person-img {
    width: 20px;
    height: 20px;
    margin: 15px 10px;
  }
  .person-name {
    color: #fff;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue